<template>
	<div class="hiq-digital-resources__message hiq-search-message">
    <p class="hiq-digital-resources__message-text hiq-search-message__text"
      aria-live="polite" v-if="!loading">
        Listan innehåller {{ total }} objekt.
    </p>
	</div>
</template>

<script lang="ts">
import Vue from 'vue';

interface IMessageComputed {
  total: number;
  loading: boolean
}

export default Vue.extend<{}, {} ,IMessageComputed ,{} >({
	name: 'Message',
	computed: {
    total() {
      return this.$store.getters.total;
    },
    loading() {
      return this.$store.getters.loading;
    }
	},
})
</script>